"use strict";
function _(t) {
  return !!(t && t.__CANCEL__);
}
export {
  _ as default
};
//# sourceMappingURL=index.es127.js.map
